<template>
	<select class="form-control" v-bind:multiple="multiple">
		<slot></slot>
	</select>
</template>

<script>
	export default {
		props: {
			options: Array, 
			value: [Number, Array, String],
			multiple: Boolean
		},
		mounted: function () {
			var vm = this
			$(this.$el)
				// init select2
				.select2({ 
					data: this.options,
					theme: "bootstrap"
				})
				.val(this.value)
				.trigger('change')
				// emit event on change.
				.on('change', function () {
					if (! this.multiple) {
						console.log('select2 changed - single-select mode', this.value);
						vm.$emit('input', this.value)
					}
				})
				.on('select2:select', function(event) {
					if (this.multiple) {
						console.log('select2 changed - multi-select mode');
						
						var values = [];
						// copy all option values from selected

						$(event.currentTarget).find("option:selected").each(function(i, selected){
							console.log('selected option', selected.value)
							values[i] = $(selected).val();
						});
						console.log('select2:select - multi-select mode values', values, event.params.valueOf());
						vm.$emit('input', values)
					}
				})
				.on('select2:unselect', function(event) {
						if (this.multiple) {
							console.log('select2 changed - multi-select mode - unselect');

							var values = [];
							// copy all option values from selected
		
							$(event.currentTarget).find("option:selected").each(function(i, selected){
								values[i] = $(selected).val();
							});
							console.log('select2:select - multi-select mode values', values, event.params.valueOf());
							vm.$emit('input', values)
						}
		
					});
		},
		watch: {
			value: function (value) {
				// update value
				$(this.$el).val(value);
			},
			options: function (options) {
				// update options
				$(this.$el).empty().select2({
					data: options,
					theme: "bootstrap"
				});
			}
		},
		destroyed: function () {
			$(this.$el).off().select2('destroy');
		}
	}
</script>